import React, { useEffect, useState } from "react";
import Select, { StylesConfig } from "react-select";

import { SelectOptions } from "../../models/forms.model";
interface FormFieldProps {
  labelText?: string;
  OptionalText?: string;
  placeholder?: string;
  value?: any;
  readonly?: boolean;
  name: string;
  type: string;
  onChange: ((e: React.ChangeEvent<any>) => void) & ((values: any) => void);
  options?: SelectOptions[];
  errors?: any;
  touched?: any;
  parentDivClass?: string;
  inputFieldClass?: string;
  title?: string;
  isSearchable?: boolean;
  onFocus?: (e: React.ChangeEvent<any>) => void;
  onBlur?: (e: React.ChangeEvent<any>) => void;
  maxLength?:number;
  numbersWithRestrictedLimit?:boolean
  handleLoading?:{enable:boolean,inputValue:string}
  isOptionDisable?: boolean;
  dataTestId?:string;
  showStaricInCaseOfRequired?: boolean;
  showErrorOnChange?: boolean;
  inputDisable?: boolean
}

const FormField: React.FC<FormFieldProps> = ({
  labelText,
  OptionalText,
  name,
  type,
  onChange,
  value,
  readonly,
  errors,
  touched,
  options,
  parentDivClass,
  inputFieldClass,
  placeholder,
  title,
  isSearchable,
  onFocus,
  onBlur,
  maxLength,
  numbersWithRestrictedLimit=false,
  handleLoading={enable:false,inputValue:''},
  isOptionDisable,
  dataTestId,
  showStaricInCaseOfRequired = false,
  showErrorOnChange = false,
  inputDisable = false
}) => {

  const [inputProps, setInputProps] = useState<any>({});
  const [isTouched, setIsTouched] = useState<boolean>(false); // Local touched state

  useEffect(() => {
    if(handleLoading.enable){
      setInputProps({...inputProps, noOptionsMessage : ({ inputValue: string }) => handleLoading.inputValue})
    }
  },[handleLoading])

function numberOnly(e) {
  e.target.value = e.target.value.replace(/[^0-9]/gi, "");
}

// `isOptionDisabled` function to disable options if 5 are already selected
  const isOptionDisabled = (option: SelectOptions) => {
  if (type.toLowerCase() === "multiselect" && Array.isArray(value)) {
    return value.length >= 5 && !value.some((selected) => selected.value === option.value);
  }
  return false;
};

 // Custom styles to visually indicate disabled options
 let customStyles: StylesConfig<SelectOptions, boolean> = {
  option: (provided, state) => {
    return ({
    ...provided,
    color: state.isDisabled ? "#999999 !important" : "#000", // Gray out the text if disabled
    backgroundColor: state.isDisabled ? "#f5f5f5 !important" : state.isFocused ? "#e5f4ff" : "#fff", // Lighter background for disabled options
    cursor: state.isDisabled ? "not-allowed !important" : "pointer", // Show not-allowed cursor for disabled options
  })},
  control: (provided) => ({
    ...provided,
    borderColor: errors[name] && touched[name] ? "red" : provided.borderColor,
    boxShadow: errors[name] && touched[name] ? "0 0 0 1px red" : provided.boxShadow,
  }),
};


const handleBlur = (e: any) => {
  if(showErrorOnChange) setIsTouched(true); // Mark as touched on blur
  onBlur?.(e); // forward to parent
};
const handleChange = (e: any) => {
  if (!isTouched && showErrorOnChange) setIsTouched(true); // Mark as touched on first change
  onChange(e); // forward change
};

const showError = showErrorOnChange && (errors[name] && (touched[name] || isTouched)); // ✅ Flexible error visibility
  return (
    <div className={`form-group ${parentDivClass ? parentDivClass : ""}`}>
      {/* {!OptionalText ? <label>{labelText}</label> : <label className="d-flex justify-content-between">{labelText} <span className="f-s14 text-transform-none font-rale f-w5 ls-normal">{OptionalText}</span></label>} */}
      {labelText && !OptionalText ? <label>{labelText}{showStaricInCaseOfRequired&&<span className="clr-red-dark" style={{fontFamily: "sans-serif", paddingLeft: '2px'}}>*</span>}</label> : <label className="d-flex justify-content-between">{labelText} <span className="f-s14 text-transform-none font-rale f-w5 ls-normal">{OptionalText}</span></label>}
      {type.toLowerCase() === "select" ||
      type.toLowerCase() === "multiselect" ? (
        <div className={`form-group ${inputFieldClass ? inputFieldClass : ""}`} data-testid={dataTestId}>
          <Select
            key={isOptionDisable ? value?.length : null} // Add a dynamic key to force re-render
            value={value}
            options={options}
            classNamePrefix="react-select"
            className={errors[name] && touched[name] ? 'input_error' : ''}
            placeholder={placeholder}
            isSearchable={isSearchable ? true : false}
            getOptionLabel={(option: any) => option.label}
            getOptionValue={(option: any) => option.value}
            onChange={onChange}
            isMulti={type.toLowerCase() === "multiselect"}
            {...(isOptionDisable ? { isOptionDisabled } : {})} 
            styles={isOptionDisable ? customStyles : ''} // Applied custom styles
            isClearable={true}
            {...inputProps}
            />
        </div>
      ) : (
        <input
          name={name}
          type={type}
          className={`form-control ${inputFieldClass ? inputFieldClass : ""} ${errors[name] && touched[name] ? 'input_error' : ''} ${inputDisable && "inputDisable"}`}
          onChange={(e) => {
            if (numbersWithRestrictedLimit) numberOnly(e);
            handleChange(e);
          }}
          value={value}
          placeholder={placeholder}
          readOnly={readonly}
          title={title}
          onBlur={handleBlur}
          onFocus={onFocus}
          maxLength={maxLength}
          data-testid={dataTestId}
        />
      )}
      {showError && (
        <span className={"clr-dark-red f-s14 font-rale mt-1 d-inline-block"}>{errors[name]}</span>
      )}
      {!showError && errors && touched && errors[name] && touched[name] && (
        <span className={"clr-dark-red f-s14 font-rale mt-1 d-inline-block"}>{errors[name]}</span>
      )}
    </div>
  );
};

export { FormField };
